var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as R from "ramda";
const getExternalResources = (structure) => {
  return R.pipe(
    R.pathOr([], ["data", "dataflows", 0, "annotations"]),
    R.reduce((acc, annotation) => {
      if (R.pipe(
        R.prop("type"),
        R.complement(R.equals)("EXT_RESOURCE")
      )(annotation)) {
        return acc;
      }
      const split = R.pipe(
        R.prop("text"),
        R.when(R.isNil, R.always("")),
        R.split("|")
      )(annotation);
      if (R.length(split) < 2) {
        return acc;
      }
      const parse = R.pipe(R.take(3), ([label, link, img]) => ({
        label,
        link,
        img
      }))(split);
      return R.append(
        __spreadValues({
          id: `EXT_RESOURCE_${R.length(acc)}`
        }, parse),
        acc
      );
    }, [])
  )(structure);
};
export {
  getExternalResources
};
